export default __webpack_public_path__ + "static/media/rocketProjectIcon.53f66446.png";